export default __webpack_public_path__ + "static/media/prenda1.2ab525f4.jpg";